import React from "react";
import PaymentProtection from "../../assets/svg/PaymentProtection";
import CouponIcon from "../../assets/svg/CouponIcon";
import ArrowRight from "../../assets/svg/ArrowRight";
import FlashIcon from "../../assets/svg/FlashIcon";
import logo from "../../assets/icon/hayd_icon.avif";
import useCoupon from "../../hooks/useCoupon";
import useCart from "../../hooks/useCart";
import useLoader from "../../hooks/useLoader";
import axiosPrivate from "../../axios/axiosPrivate";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";

const PlaceOrderFree = ({ regularPrice, comparePrice }) => {
  const { cartData } = useCart();
  const { couponData } = useCoupon();
  const { setLoading } = useLoader();
  const { user } = useAuth();
  const navigate = useNavigate();

  //   const onlinePayment = async () => {
  //     try {
  //       const couponApplied = couponData?.applied;
  //       const couponCode = couponData?.appliedCoupon?.coupon_name;
  //       const cart = [];

  //       cartData?.items?.map((data) => {
  //         const isUpsell = data?.properties?.upsell_discount === "true";
  //         const upsellPrice = data?.properties?.upsell_price;
  //         cart?.push({
  //           variant_id: data?.variant_id,
  //           quantity: data?.quantity,
  //           original_price: data?.price,
  //           ...(isUpsell && upsellPrice && { price: upsellPrice }),
  //         });
  //       });

  //       const payload = {
  //         cart,
  //         couponApplied,
  //         couponCode,
  //         payment_method: "online",
  //         osName: "WEB",
  //       };

  //       setLoading(true);
  //       const response = await axiosPrivate.post("/orders/create-order", payload);
  //       const draftOrderId = response?.data?.draftOrderId;

  //       const options = {
  //         description: "HAYD Brands",
  //         image: logo,
  //         currency: "INR",
  //         key: response?.data?.key,
  //         amount: response?.data?.amount,
  //         name: "HAYD Brands",
  //         order_id: response?.data?.razorpayOrderId,
  //         method: {
  //           upi: true,
  //           card: false,
  //           netbanking: false,
  //           wallet: false,
  //           emi: false,
  //           paylater: false,
  //         },
  //         prefill: {
  //           email: user?.email ? user?.email : "",
  //           contact: user?.phone,
  //           name:
  //             user?.first_name === "HAYD_USER"
  //               ? "User"
  //               : user?.first_name + " " + user?.last_name,
  //         },
  //         theme: { color: "#000000" },
  //         handler: function (paymentResponse) {
  //           setLoading(false);
  //           navigate("/thank-you", {
  //             state: { draftOrderId },
  //             replace: true,
  //           });
  //         },
  //         modal: {
  //           ondismiss: function () {
  //             setLoading(false);
  //             console.log("inside dismiss where all order get delete");
  //             // DELETE DRAFT ORDER WHICH IS CREATED
  //             if (draftOrderId) {
  //               try {
  //                 const deleteDraftorder = axiosPrivate.delete(
  //                   `/orders/delete-draft-order`,
  //                   {
  //                     data: { draftOrderId },
  //                   }
  //                 );
  //               } catch (error) {
  //                 console.log("hello");
  //               }
  //             }
  //             console.log("Payment popup closed");
  //           },
  //         },
  //       };

  //       const rzp = new window.Razorpay(options);

  //       rzp.on("payment.failed", function (response) {
  //         setLoading(false);
  //         console.log("Payment failed:");
  //       });

  //       rzp.open();
  //     } catch (error) {
  //       console.log(error?.response?.data || error?.message);
  //       setLoading(false);
  //     }
  //   };

  const codPayment = async () => {
    try {
      const couponApplied = couponData?.applied;
      const couponCode = couponData?.appliedCoupon?.coupon_name;
      const cart = [];

      cartData?.items?.map((data) => {
        const isUpsell = data?.properties?.upsell_discount === "true";
        const upsellPrice = data?.properties?.upsell_price;
        cart?.push({
          variant_id: data?.variant_id,
          quantity: data?.quantity,
          original_price: data?.price,
          ...(isUpsell && upsellPrice && { price: upsellPrice }),
        });
      });

      const payload = {
        cart,
        couponApplied,
        couponCode,
        payment_method: "free_product",
        osName: "WEB",
      };

      setLoading(true);
      const response = await axiosPrivate.post(
        "/orders/place-free-order",
        payload
      );

      const productIds = response?.data?.line_items.map(
        (item) => item.product_id
      );
      // REDIRECT WHEN USING IFRAME ONLY
      // window.location.href = response?.data?.order_status_url;

      // REDIRECT FOR SHOPIFY
      window.parent.postMessage(
        {
          type: "REDIRECT_TO_URL",
          payload: response?.data?.order_status_url,
          orderAmount: response?.data?.total_price,
          contentId: productIds || [],
        },
        "*"
      );
    } catch (error) {
      console.log(error?.response?.data || error?.message);
      setLoading(false);
    }
  };

  return (
    <div
      className="py-4 flex justify-between gap-2 items-start cursor-pointer hover:bg-gray-50"
      onClick={codPayment}
    >
      <div className="flex items-start gap-2">
        <div className="border border-1 px-[3px] py-[2px]  border-gray-400 rounded-[4px]">
          <PaymentProtection width={18} height={18} />
        </div>
        <div>
          <div className="flex items-center gap-[2px] break-words flex-wrap">
            <p className="text-[16px] supreme-medium">Place Order</p>
            <FlashIcon width={14} height={14} className="text-blue-500" />
          </div>
          <div className="mt-2 flex items-center gap-1">
            <CouponIcon width={14} height={14} className="fill-green-700" />
            <p className="text-[14px] general-sans-regular text-green-700">
              Save ₹{regularPrice}
            </p>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="flex items-baseline gap-2 break-words flex-wrap">
          <p className="text-[14px] supreme-medium line-through text-gray-500">
            ₹
            {couponData?.appliedCoupon?.discountAmount
              ? regularPrice
              : comparePrice}
          </p>
          <p className="text-[16px] supreme-bold">₹0</p>
        </div>

        <ArrowRight width={14} height={14} className="fill-gray-500" />
      </div>
    </div>
  );
};

export default PlaceOrderFree;
